import { Suspense } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import EmployeeHeader from "../components/EmployeeHeader"; 
import EmployeeHeader2 from "../components/EmployeeHeader2"; 
import Empleados from "../pages/Empleados";
import Admin from "../pages/Empleados/admin";
import Empleado from "../pages/Empleados/empleado";
import Home from "../pages/Home";
import { Styles } from "../styles/styles";
import ProtectedRoute from "../components/ProtectedRoute";

const Router = () => {
  const location = useLocation();

  // Detectar las rutas
  const isEmployeePage = location.pathname.startsWith("/empleados");
  const isAdminPage = location.pathname === "/empleados/admin";
  const isDashboardPage = location.pathname === "/empleados/dashboard";

  return (
    <Suspense fallback={null}>
      <Styles />
      {isAdminPage || isDashboardPage ? (
        <EmployeeHeader2 />
      ) : isEmployeePage ? (
        <EmployeeHeader />
      ) : (
        <Header />
      )}
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/home" exact component={Home} />
        <Route path="/empleados" exact component={Empleados} />
        <ProtectedRoute path="/empleados/admin" exact component={Admin} requiredRole="admin"/>
        <ProtectedRoute path="/empleados/dashboard" exact component={Empleado} requiredRole="empleado"/>
      </Switch>
      {!isEmployeePage && <Footer />}
    </Suspense>
  );
};

export default Router;